import { ColumnDef } from '@tanstack/react-table';
import { PopupWraper, TableListData } from 'components';
import React, { useEffect, useState } from 'react';
import { useGetMyReferraQuery } from 'services';
import { GetMyRefferals } from 'services/openapi';
import { columnsDefined } from './config';

type Props = {
  isOpen: boolean;
  isLoadingProcess?: boolean;
  onSuccess?: ({ refferalCode }: { refferalCode: string }) => void;
  onClose?: () => void;
};

const ModalMyRefferal = (props: Props) => {
  const { isOpen, onClose } = props;

  const [isShowPopup, setIsShowPopup] = useState<boolean>(isOpen);

  useEffect(() => {
    setIsShowPopup(isOpen);
  }, [isOpen]);

  if (!isShowPopup) return <></>;

  return (
    <PopupWraper
      center
      title='Danh sách Người dùng được giới thiệu'
      onClose={() => {
        setIsShowPopup(false);
        onClose && onClose();
      }}
    >
      <TableListData<GetMyRefferals>
        columns={columnsDefined as ColumnDef<GetMyRefferals>[]}
        useQuery={useGetMyReferraQuery}
      />
    </PopupWraper>
  );
};

export default ModalMyRefferal;
